import { createSlice, PayloadAction, current } from '@reduxjs/toolkit'
import { WorklistExam } from '../../model/exam'

import { WorklistFiltersType, WorklistState } from '../../model/model'
import { worklistApi } from '../../services/worklist'

export const initialState = {
	worklistFilters: {
		dateFrom: new Date().toISOString(),
		technician: ['all'],
		chartStatus: 'all',
		dateRange: false,
		onlyRemote: false,
		cpt: [],
		icd10: [],
		loinc: [],
		snomed: [],
		dateTo: null,
		status: [],
	},
	currentPaginationPage: 1,
	paginationTotalPages: 0,
} as WorklistState

const { getWorklist } = worklistApi.endpoints

export const slice = createSlice({
	name: 'worklist',
	initialState,
	reducers: {
		setFilters: (
			state,
			{ payload }: PayloadAction<Partial<WorklistFiltersType>>,
		) => {
			state.worklistFilters = {
				...current(state.worklistFilters),
				...payload,
			}
			state.currentPaginationPage = 1
		},
		resetFilters: state => {
			state.worklistFilters = initialState.worklistFilters
		},
		setCurrentPaginationPage: (state, { payload }: PayloadAction<number>) => {
			state.currentPaginationPage = payload
		},
		setPaginationTotalPages: (state, { payload }: PayloadAction<number>) => {
			state.paginationTotalPages = payload
		},
	},
	extraReducers: builder => {
		builder.addMatcher(
			getWorklist.matchFulfilled,
			(
				state,
				{
					payload,
				}: PayloadAction<{ exams: WorklistExam[]; totalResults: number }>,
			) => {
				state.paginationTotalPages = Math.ceil(payload.totalResults / 10)
			},
		)
	},
})

export default slice.reducer
